<template>
  <div class="card card-custom gutter-b">
    <!--begin::Header-->
    <div class="card-header border-0 pt-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label font-weight-bolder text-dark">
          Últimos
          {{
            fluxosFiltrados.length > fluxosDeCaixaQuantidadeTotal
              ? fluxosDeCaixaQuantidadeTotal
              : fluxosFiltrados.length
          }}
          Títulos (Total de {{ fluxosDeCaixaQuantidadeTotal }} no Período)
        </span>
        <b-dropdown
          class="mx-1"
          text="Opções"
          style="
            margin-left: 0 !important;
            margin-top: 0.65rem !important;
            margin-right: 0 !important;
          "
          v-if="quantidadeSelecionados() > 0"
        >
          <b-dropdown-item @click="efetuarPagamento" v-if="fgModoPR !== 'R'"
            >Pagar Paylogos</b-dropdown-item
          >
          <b-dropdown-item v-if="fgModoPR !== 'R'">
            Pagar
          </b-dropdown-item>
          <b-dropdown-item @click="liberarTitulo" v-if="fgModoPR !== 'R'"
            >Liberar</b-dropdown-item
          >
          <b-dropdown-item @click="aprovarTitulo" v-if="fgModoPR !== 'R'"
            >Aprovar</b-dropdown-item
          >
          <b-dropdown-item @click="contabilizaTotal"
            >Valor Total</b-dropdown-item
          >
        </b-dropdown>
        <span class="text-muted mt-3 font-weight-bold font-size-sm">
          Acompanhe em tempo real todos os títulos feitos pelo seu
          estabelecimento
        </span>
        <span class="text-muted mt-3 font-weight-bold font-size-sm">
          Valor Total:
          {{
            fluxosDeCaixaQuantidadeValor.toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL"
            })
          }}
        </span>
        <span class="text-muted mt-3 font-weight-bold font-size-sm">
          <b-button
            class="mr-3 btn-sm"
            @click="marcarDesmarcarTudo"
            style="height: 20px; padding: 0px; padding-left: 4px; padding-right: 4px;"
          >
            {{ marcarDesmarcar ? "Desmarcar Tudo" : "Marcar Tudo" }}
          </b-button>
        </span>
      </h3>
      <div class="card-toolbar">
        <div class="input-icon h-40px">
          <input
            type="text"
            class="form-control form-control-lg form-control-solid h-40px"
            v-model="buscaFluxoTexto"
            placeholder="Buscar..."
          />
          <span>
            <span class="svg-icon svg-icon-lg">
              <!--begin::Svg Icon-->
              <inline-svg src="media/svg/icons/General/Search.svg" />
              <!--end::Svg Icon-->
            </span>
          </span>
        </div>
      </div>
    </div>
    <!--end::Header-->
    <!--begin::Body-->
    <div
      @scroll="handleScroll"
      class="card-body pt-2 pb-0"
      style="max-height: 418px; overflow-y: auto; overflow-x: auto"
    >
      <!--begin::Table-->
      <div class="table-responsive" style="overflow-x: initial">
        <table class="table table-borderless table-vertical-center">
          <thead>
            <tr>
              <th class="p-0" style="width: 50px"></th>
              <th class="p-0" style="width: 50px"></th>
              <th class="p-0" style="min-width: 150px"></th>
              <th class="p-0" style="min-width: 30px"></th>
              <th class="p-0" style="min-width: 70px"></th>
              <th class="p-0" style="min-width: 70px"></th>
              <th class="p-0" style="min-width: 50px"></th>
            </tr>
          </thead>
          <tbody v-if="fluxosDeCaixaQuantidadeTotal">
            <template v-for="(item, i) in fluxosFiltrados">
              <tr :key="i">
                <td class="pl-0">
                  <div class="symbol symbol-50 symbol-light mr-2 mt-2">
                    <b-form-checkbox
                      size="lg"
                      @change="selecionar(item)"
                      :checked="item.selecionado"
                    ></b-form-checkbox>
                  </div>
                </td>
                <td class="pl-0">
                  <div class="symbol symbol-50 symbol-light mr-2 mt-2">
                    <span class="symbol-label">
                      <img
                        :src="retornaAvatar(item)"
                        class="h-75 align-self-end"
                        alt=""
                      />
                    </span>
                  </div>
                </td>
                <td class="pl-0">
                  <a
                    href="javascript:;"
                    @click="$emit('selecionarFluxo', { fluxo: item, opcao: 1 })"
                    class="
                            text-dark
                            font-weight-bolder
                            text-hover-primary
                            mb-1
                            font-size-lg
                            "
                    :class="{
                      receber: fgModoPR == 'R',
                      pagar: fgModoPR == 'P'
                    }"
                  >
                    {{ item.EMITENTE }}
                  </a>
                  <span class="text-muted font-weight-bold d-block">
                    {{ item.HISTORICO }}
                    <b-badge
                      v-if="item.GEDS"
                      class="mr-1"
                      variant="success"
                      style="padding: 3px 5px; margin-left: 4px;"
                    >
                      {{ item.GEDS }} GED
                    </b-badge>
                  </span>
                  <span class="text-muted font-weight-bold d-block" style="white-space: nowrap;">
                    {{ item.EMPRESA_SIGLA ? item.EMPRESA_SIGLA : "" }}
                    {{ ((item.EMPRESA_SIGLA) && (item.PROJETO)) ? " / " : "" }}
                    {{ item.PROJETO ? item.PROJETO : "" }}
                    {{ item.EMPRESA_PROJETO_SIGLA ? "." + item.EMPRESA_PROJETO_SIGLA : "" }}
                    <span
                      v-if="
                        item.LGPD &&
                          item.LGPD.ID_LGPD &&
                          item.LGPD.PERMITIDO == '1'
                      "
                    >
                      <b-badge
                        class="mr-1"
                        variant="primary"
                        style="
                                padding: 3px;
                                padding-left: 5px;
                                padding-right: 5px;
                                margin-left: 5px;
                                "
                      >
                        LGPD ok
                      </b-badge>
                    </span>
                    <span v-if="item.BB">
                      <img
                        src="media/logos/bb.jpg"
                        style="width: 20px; border-radius: 50%"
                      />
                    </span>
                    <span v-if="item.ZOOP">
                      <img
                        src="media/logos/zoop.png"
                        style="width: 20px; border-radius: 50%"
                      />
                    </span>
                  </span>
                </td>
                <td></td>
                <td class="text-right">
                  <span
                    class="text-muted font-weight-bold d-block font-size-sm"
                  >
                    {{ retornaStatusPagamento(item) }} <br />
                    <span>
                      <b-badge
                        v-if="!item.DATA_COMPENSACAO && item.STAT == 'A'"
                        class="mr-1"
                        variant="secondary"
                        style="
                                    padding: 3px;
                                    padding-left: 5px;
                                    padding-right: 5px;
                                    margin-left: 5px;
                                "
                      >
                        Aprovado
                        {{
                          item.USUARIO_ULTIMO_STATUS
                            ? " - " + item.USUARIO_ULTIMO_STATUS
                            : ""
                        }}
                      </b-badge>
                      <b-badge
                        v-if="!item.DATA_COMPENSACAO && item.STAT == 'L'"
                        class="mr-1"
                        variant="warning"
                        style="
                                    padding: 3px;
                                    padding-left: 5px;
                                    padding-right: 5px;
                                    margin-left: 5px;
                                "
                      >
                        Liberado
                        {{
                          item.USUARIO_ULTIMO_STATUS
                            ? " - " + item.USUARIO_ULTIMO_STATUS
                            : ""
                        }}
                      </b-badge>
                      <b-badge
                        v-if="!item.DATA_COMPENSACAO && item.STAT == 'B'"
                        class="mr-1"
                        variant="danger"
                        style="
                                    padding: 3px;
                                    padding-left: 5px;
                                    padding-right: 5px;
                                    margin-left: 5px;
                                "
                      >
                        Bloqueado
                        {{
                          item.USUARIO_ULTIMO_STATUS
                            ? " - " + item.USUARIO_ULTIMO_STATUS
                            : ""
                        }}
                      </b-badge>
                      <b-badge
                        v-if="item.DATA_COMPENSACAO"
                        class="mr-1"
                        variant="primary"
                        style="
                                    padding: 3px;
                                    padding-left: 5px;
                                    padding-right: 5px;
                                    margin-left: 5px;
                                "
                      >
                        Compensado
                      </b-badge>
                    </span>
                  </span>
                  <span
                    class="text-dark-75 font-weight-bolder d-block font-size-lg"
                    v-html="retornaValorPago(item)"
                  ></span>
                </td>
                <td class="text-center">
                  <transition-group name="fade" enter-active-class="animated flip">
                    <div v-show="(item.menu == 0) || (!item.menu)" :key="0">
                      <span class="text-muted font-weight-bold d-block font-size-sm" style="white-space: nowrap; margin-bottom: 4px;">
                        <b-button class="btn-mudar-data-tipo" size="sm" style="margin-right: 3px;" @click="mudaDataTipo(item, 'voltar')">&lsaquo;</b-button>
                        Vencimento
                        <b-button class="btn-mudar-data-tipo" size="sm" style="margin-left: 3px;" @click="mudaDataTipo(item, 'avancar')">&rsaquo;</b-button>
                      </span>
                      <span class="font-weight-bolder text-primary" :class="{receber: fgModoPR == 'R', pagar: fgModoPR == 'P'}" v-if="item.DATA_VENCIMENTO">
                        {{ formataData(item.DATA_VENCIMENTO) }}
                      </span>
                      <span class="font-weight-bolder text-primary" :class="{receber: fgModoPR == 'R', pagar: fgModoPR == 'P'}" v-if="!item.DATA_VENCIMENTO">
                        --/--/----
                      </span>
                    </div>
                    <div v-show="item.menu == 1" :key="1">
                      <span class="text-muted font-weight-bold d-block font-size-sm" style="white-space: nowrap; margin-bottom: 4px;">
                        <b-button class="btn-mudar-data-tipo" size="sm" style="margin-right: 3px;" @click="mudaDataTipo(item, 'voltar')">&lsaquo;</b-button>
                        Pagamento
                        <b-button class="btn-mudar-data-tipo" size="sm" style="margin-left: 3px;" @click="mudaDataTipo(item, 'avancar')">&rsaquo;</b-button>
                      </span>
                      <span class="font-weight-bolder text-primary" :class="{receber: fgModoPR == 'R', pagar: fgModoPR == 'P'}" v-if="item.DATA_PAGAMENTO">
                        {{ formataData(item.DATA_PAGAMENTO) }}
                      </span>
                      <span class="font-weight-bolder text-primary" :class="{receber: fgModoPR == 'R', pagar: fgModoPR == 'P'}" v-if="!item.DATA_PAGAMENTO">
                        --/--/----
                      </span>
                    </div>
                    <div v-show="item.menu == 2" :key="2">
                      <span class="text-muted font-weight-bold d-block font-size-sm" style="white-space: nowrap; margin-bottom: 4px;">
                        <b-button class="btn-mudar-data-tipo" size="sm" style="margin-right: 3px;" @click="mudaDataTipo(item, 'voltar')">&lsaquo;</b-button>
                        Crédito
                        <b-button class="btn-mudar-data-tipo" size="sm" style="margin-left: 3px;" @click="mudaDataTipo(item, 'avancar')">&rsaquo;</b-button>
                      </span>
                      <span class="font-weight-bolder text-primary" :class="{receber: fgModoPR == 'R', pagar: fgModoPR == 'P'}" v-if="item.DATA_CREDITO">
                        {{ formataData(item.DATA_CREDITO) }}
                      </span>
                      <span class="font-weight-bolder text-primary" :class="{receber: fgModoPR == 'R', pagar: fgModoPR == 'P'}" v-if="!item.DATA_CREDITO">
                        --/--/----
                      </span>
                    </div>
                    <div v-show="item.menu == 3" :key="3">
                      <span class="text-muted font-weight-bold d-block font-size-sm" style="white-space: nowrap; margin-bottom: 4px;">
                        <b-button class="btn-mudar-data-tipo" size="sm" style="margin-right: 3px;" @click="mudaDataTipo(item, 'voltar')">&lsaquo;</b-button>
                        Emissão
                        <b-button class="btn-mudar-data-tipo" size="sm" style="margin-left: 3px;" @click="mudaDataTipo(item, 'avancar')">&rsaquo;</b-button>
                      </span>
                      <span class="font-weight-bolder text-primary" :class="{receber: fgModoPR == 'R', pagar: fgModoPR == 'P'}" v-if="item.DATA_EMISSAO">
                        {{ formataData(item.DATA_EMISSAO) }}
                      </span>
                      <span class="font-weight-bolder text-primary" :class="{receber: fgModoPR == 'R', pagar: fgModoPR == 'P'}" v-if="!item.DATA_EMISSAO">
                        --/--/----
                      </span>
                    </div>
                    <div v-show="item.menu == 4" :key="4">
                      <span class="text-muted font-weight-bold d-block font-size-sm" style="white-space: nowrap; margin-bottom: 4px;">
                        <b-button class="btn-mudar-data-tipo" size="sm" style="margin-right: 3px;" @click="mudaDataTipo(item, 'voltar')">&lsaquo;</b-button>
                        Inclusão
                        <b-button class="btn-mudar-data-tipo" size="sm" style="margin-left: 3px;" @click="mudaDataTipo(item, 'avancar')">&rsaquo;</b-button>
                      </span>
                      <span class="font-weight-bolder text-primary" :class="{receber: fgModoPR == 'R', pagar: fgModoPR == 'P'}" v-if="item.DATA_INCLUSAO">
                        {{ formataData(item.DATA_INCLUSAO) }}
                      </span>
                      <span class="font-weight-bolder text-primary" :class="{receber: fgModoPR == 'R', pagar: fgModoPR == 'P'}" v-if="!item.DATA_INCLUSAO">
                        --/--/----
                      </span>
                    </div>
                    <div v-show="item.menu == 5" :key="5">
                      <span class="text-muted font-weight-bold d-block font-size-sm" style="white-space: nowrap; margin-bottom: 4px;">
                        <b-button class="btn-mudar-data-tipo" size="sm" style="margin-right: 3px;" @click="mudaDataTipo(item, 'voltar')">&lsaquo;</b-button>
                        Alteração
                        <b-button class="btn-mudar-data-tipo" size="sm" style="margin-left: 3px;" @click="mudaDataTipo(item, 'avancar')">&rsaquo;</b-button>
                      </span>
                      <span class="font-weight-bolder text-primary" :class="{receber: fgModoPR == 'R', pagar: fgModoPR == 'P'}" v-if="item.DATA_ALTERACAO">
                        {{ formataData(item.DATA_ALTERACAO) }}
                      </span>
                      <span class="font-weight-bolder text-primary" :class="{receber: fgModoPR == 'R', pagar: fgModoPR == 'P'}" v-if="!item.DATA_ALTERACAO">
                        --/--/----
                      </span>
                    </div>
                  </transition-group>
                </td>
                <td class="text-right pr-0">
                  <a
                    href="javascript:;"
                    @click="$emit('selecionarFluxo', { fluxo: item, opcao: 2 })"
                    class="btn btn-icon btn-light btn-sm"
                  >
                    <span class="svg-icon svg-icon-md svg-icon-success">
                      <!--begin::Svg Icon | path:assets/media/svg/icons/Navigation/Arrow-right.svg-->
                      <inline-svg
                        src="media/svg/icons/Navigation/Arrow-right.svg"
                      />
                      <!--end::Svg Icon-->
                    </span>
                  </a>
                </td>
              </tr>
            </template>
            <template
              v-if="fluxosFiltrados.length < fluxosDeCaixaQuantidadeTotal"
            >
              <tr>
                <td colspan="7">
                  <a
                    href="javascript:;"
                    @click="exibirMais"
                    class="
                      btn btn-block btn-sm 
                      font-weight-bolder
                      text-uppercase
                    "
                    :class="{
                      receber: fgModoPR == 'R',
                      pagar: fgModoPR == 'P',
                      'btn-primary': !fgLoading,
                      'btn-secundary': fgLoading
                    }"
                    :disabled="fgLoading"
                    style="display: none;"
                  >
                    Mostrar mais
                  </a>
                </td>
              </tr>
            </template>
          </tbody>
          <tbody v-if="!fluxosDeCaixaQuantidadeTotal">
            <tr>
              <td class="pl-0"></td>
              <td class="pl-0">
                <div class="symbol symbol-50 symbol-light mr-2 mt-2">
                  <span class="symbol-label">
                    <img
                      :src="
                        fgModoPR == 'R'
                          ? 'media/svg/avatars/001-boy.svg'
                          : 'media/svg/avatars/007-boy-2.svg'
                      "
                      class="h-75 align-self-end"
                      alt=""
                    />
                  </span>
                </div>
              </td>
              <td class="pl-0">
                <a
                  href="javascript:;"
                  class="
                    text-dark
                    font-weight-bolder
                    text-hover-primary
                    mb-1
                    font-size-lg
                  "
                >
                  Sem títulos no período e filtros realizados
                </a>
                <span class="text-muted font-weight-bold d-block"> ---- </span>
              </td>
              <td></td>
              <td class="text-right">
                <span class="text-muted font-weight-bold d-block font-size-sm">
                </span>
                <span
                  class="text-dark-75 font-weight-bolder d-block font-size-lg"
                >
                </span>
              </td>
              <td class="text-right">
                <span class="font-weight-bolder text-primary"> </span>
              </td>
              <td class="text-right pr-0"></td>
            </tr>
          </tbody>
        </table>
      </div>
      <!--end::Table-->
    </div>
    <!--end::Body-->
  </div>
</template>

<style lang="scss" scoped>
::-webkit-scrollbar {
  width: 12px;
  height: 12px;
}

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

.text-hover-primary.pagar:hover {
  color: #f64e60 !important;
}

.text-hover-primary.receber:hover {
  color: #1bc5bd !important;
}

.text-primary.receber {
  color: #1bc5bd !important;
}

.text-primary.pagar {
  color: #f64e60 !important;
}

.btn-mudar-data-tipo {
  padding: 0px;
  padding-left: 4px;
  padding-right: 4px;
  height: 18px;
}
</style>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import Swal from "sweetalert2";

export default {
  name: "widget-9",
  data() {
    return {
      timeoutBusca: null,
      marcarDesmarcar: false,
      datasTipo: 0
    };
  },
  mounted() {},
  props: ["indice"],
  computed: {
    ...mapGetters([
      "fluxosDeCaixa",
      "fluxoDeCaixaBusca",
      "fluxosDeCaixaQuantidadeTotal",
      "fluxosDeCaixaQuantidadeValor",
      "fgEmpresa",
      "fgProjeto",
      "fgPlanoFinanceiro",
      "fgCentroDeResponsabilidade",
      "fgPortador",
      "fgModoPR",
      "fgDataInicio",
      "fgDataFim",
      "fgLoading",
      "fgFiltroAbas",
      "fgDataFiltroTipo",
      "fgEmitente",
      "fgOrdenacaoFiltroTipo"
    ]),
    buscaFluxoTexto: {
      get: function() {
        return this.fluxoDeCaixaBusca;
      },
      set: function(value) {
        let vm = this;

        this.updateFluxoDeCaixaBusca(value);
        window.localStorage.setItem("buscaFluxo", value);
        window.localStorage.setItem(
          "validadeFiltroBuscaFluxo",
          moment().format("YYYY-MM-DD")
        );

        if (this.timeoutBusca) {
          clearTimeout(this.timeoutBusca);
        }

        this.timeoutBusca = setTimeout(function() {
          vm.buscarFluxos();
        }, 1000);
      }
    },
    dataToShow() {
      if (this.show === "month") return this.month;
      if (this.show === "week") return this.week;
      if (this.show === "day") return this.day;
      return this.day;
    },
    fluxosFiltrados() {
      let vm = this;

      if (this.fluxosDeCaixa) {
        if (this.fluxosDeCaixa.length) {
          return this.fluxosDeCaixa.filter(function(fluxoItem) {
            if (vm.fgEmpresa !== "0") {
              if (fluxoItem.ID_EMPRESA) {
                if (vm.fgEmpresa == fluxoItem.ID_EMPRESA) {
                  if (vm.fgProjeto !== "0") {
                    if (fluxoItem.ID_PROJETO) {
                      if (vm.fgProjeto == fluxoItem.ID_PROJETO) {
                        return true;
                      } else {
                        return false;
                      }
                    } else {
                      return false;
                    }
                  } else {
                    return true;
                  }
                } else {
                  return false;
                }
              } else {
                return false;
              }
            } else {
              if (vm.fgProjeto !== "0") {
                if (fluxoItem.ID_PROJETO) {
                  if (vm.fgProjeto == fluxoItem.ID_PROJETO) {
                    return true;
                  } else {
                    return false;
                  }
                } else {
                  return false;
                }
              } else {
                return true;
              }
            }
          });
        } else {
          return [];
        }
      } else {
        return [];
      }
    }
  },
  methods: {
    ...mapActions([
      "selectFluxoDeCaixa",
      "updatePagarTitulo",
      "getFluxosDeCaixa",
      "getZeraFluxosDeCaixa",
      "updateFgLoading",
      "updateFluxoDeCaixaBusca",
      "menuFluxoDeCaixa"
    ]),
    formataData(data) {
      return moment(data, "YYYYMMDD[T]HHmmss").format("DD/MM/YYYY");
    },
    exibirMais() {
      if (!this.fgLoading) {
        this.buscarFluxos();
      }
    },
    retornaValorPago(item) {
      if (item.VALOR_PAGO) {
        if (item.VALOR_PAGO == item.VALOR || item.LIQUIDACAO_TOTAL) {
          return item.VALOR_PAGO.toLocaleString("pt-br", {
            style: "currency",
            currency: "BRL"
          });
        } else {
          return (
            item.VALOR_PAGO.toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL"
            }) +
            "<br /> (" +
            (item.VALOR - item.VALOR_PAGO >= 0
              ? "Em aberto: " +
                (item.VALOR - item.VALOR_PAGO).toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL"
                })
              : "A mais: " +
                (-(item.VALOR - item.VALOR_PAGO)).toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL"
                })) +
            ")"
          );
        }
      } else {
        return item.VALOR.toLocaleString("pt-br", {
          style: "currency",
          currency: "BRL"
        });
      }
    },
    retornaStatusPagamento(item) {
      if (item.VALOR_PAGO) {
        return "Pago";
      } else if (item.BOLETO && item.BOLETO.ID_BOLETO_WS) {
        return "Gerado";
      } else if (item.EMAIL && item.EMAIL.ID_EMAIL_ENVIADO) {
        return "Enviado";
      } else {
        return "Em aberto";
      }
    },
    selecionar(fluxo) {
      this.selectFluxoDeCaixa(fluxo);
    },
    quantidadeSelecionados() {
      let quantidade = 0;

      this.fluxosDeCaixa.forEach(function(fluxoDeCaixa) {
        if (fluxoDeCaixa.selecionado) {
          quantidade += 1;
        }
      });

      return quantidade;
    },
    async efetuarPagamento() {
      if (this.quantidadeSelecionados() > 0) {
        let fluxosSelecionados = [];

        this.fluxosDeCaixa.forEach(function(fluxoDeCaixa) {
          if (fluxoDeCaixa.selecionado) {
            fluxosSelecionados.push({
              ID_FLUXO_DE_CAIXA: fluxoDeCaixa.ID_FLUXO_DE_CAIXA
            });
          }
        });

        let resultado = await this.updatePagarTitulo({
          fluxosDeCaixa: fluxosSelecionados,
          DESCRICAO: "Pagamentos Paylogos"
        });

        if (resultado.requestStatus == 1) {
          Swal.fire({
            title: "",
            text:
              (fluxosSelecionados.length > 1
                ? "Os títulos foram enviados "
                : "O título foi enviado ") +
              "via remessa pagamento para o banco. Dentro de 10 a 40 minutos estará disponível para a liberação no seu Internet Banking.",
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false
          });

          this.sairFluxoDetalhado();
        } else if (resultado.erro) {
          Swal.fire({
            title: "",
            text: resultado.erro,
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false
          });
        } else {
          Swal.fire({
            title: "",
            text:
              "Não foi possível efetuar o envio da remessa de pagamento. Tente novamente mais tarde ou entre em contato com o suporte.",
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false
          });
        }
      } else {
        Swal.fire({
          title: "",
          text: "Você precisa selecionar pelo menos um pagamento.",
          icon: "warning",
          timer: 3000,
          showConfirmButton: false
        });
      }
    },
    async liberarTitulo() {},
    async aprovarTitulo() {},
    async buscarFluxos() {
      this.updateFgLoading(true);

      await this.getFluxosDeCaixa({
        inicio: this.fgDataInicio,
        fim: this.fgDataFim,
        empresa: this.fgEmpresa,
        projeto: this.fgProjeto,
        planoFinanceiro: this.fgPlanoFinanceiro,
        centroDeResponsabilidade: this.fgCentroDeResponsabilidade,
        portador: this.fgPortador,
        tipo: this.fgModoPR,
        fluxoDeCaixaBusca: this.fluxoDeCaixaBusca,
        filtroAbas: this.fgFiltroAbas,
        dataFiltroTipo: this.fgDataFiltroTipo,
        emitente: this.fgEmitente,
        ordenacaoFiltroTipo: this.fgOrdenacaoFiltroTipo
      });

      this.updateFgLoading(false);
    },
    sairFluxoDetalhado() {
      this.getZeraFluxosDeCaixa({
        inicio: this.fgDataInicio,
        fim: this.fgDataFim,
        empresa: this.fgEmpresa,
        projeto: this.fgProjeto,
        planoFinanceiro: this.fgPlanoFinanceiro,
        centroDeResponsabilidade: this.fgCentroDeResponsabilidade,
        portador: this.fgPortador,
        tipo: this.fgModoPR,
        fluxoDeCaixaBusca: this.fluxoDeCaixaBusca,
        filtroAbas: this.fgFiltroAbas
      });

      this.$nextTick(() => {
        this.buscarFluxos();
      });
    },
    retornaAvatar(item) {
      let tratamento = item.EMITENTE_TRATAMENTO;
      let pessoa = item.EMITENTE_PESSOA;

      if (pessoa && pessoa == "J") {
        return "media/svg/avatars/051-company.png";
      } else {
        if (tratamento) {
          if (tratamento.toUpperCase().indexOf("A.") >= 0) {
            if (this.fgModoPR == "R") {
              return "media/svg/avatars/010-girl-4.svg";
            } else {
              return "media/svg/avatars/003-girl-1.svg";
            }
          } else {
            if (this.fgModoPR == "R") {
              return "media/svg/avatars/001-boy.svg";
            } else {
              return "media/svg/avatars/007-boy-2.svg";
            }
          }
        } else {
          if (this.fgModoPR == "R") {
            return "media/svg/avatars/001-boy.svg";
          } else {
            return "media/svg/avatars/007-boy-2.svg";
          }
        }
      }
    },
    contabilizaTotal() {
      let valor = 0;

      this.fluxosDeCaixa.forEach(function(fluxoDeCaixa) {
        if (fluxoDeCaixa.selecionado) {
          valor += fluxoDeCaixa.VALOR;
        }
      });

      Swal.fire({
        title: "",
        text:
          "Valor total de: " +
          valor.toLocaleString("pt-br", { style: "currency", currency: "BRL" }),
        icon: "info",
        timer: 3000,
        showConfirmButton: false
      });
    },
    marcarDesmarcarTudo() {
      if (this.marcarDesmarcar) {
        this.marcarDesmarcar = false;

        this.fluxosDeCaixa.forEach(function(fluxoDeCaixa) {
          fluxoDeCaixa.selecionado = false;
        });
      } else {
        this.marcarDesmarcar = true;

        this.fluxosDeCaixa.forEach(function(fluxoDeCaixa) {
          fluxoDeCaixa.selecionado = true;
        });
      }
    },
    handleScroll(event) {
      if (
        Math.floor(event.target.scrollHeight - event.target.scrollTop) ==
        event.target.clientHeight
      ) {
        if (!this.fgLoading) {
          if (this.fluxosFiltrados.length < this.fluxosDeCaixaQuantidadeTotal) {
            this.buscarFluxos();
          }
        }
      }
    },
    mudaDataTipo(item, tipo) {
      let retorno = 0;

      if(tipo == 'voltar') {
        if((item.menu == 0) || (!item.menu)) {
          retorno = 5;
        } else {
          retorno = item.menu - 1;
        }
      } else {
        if(item.menu == 5) {
          retorno = 0;
        } else {
          if(!item.menu) {
            retorno = 1;
          } else {
            retorno = item.menu + 1;
          }
        }
      }

      this.menuFluxoDeCaixa({
        ID_FLUXO_DE_CAIXA: item.ID_FLUXO_DE_CAIXA,
        MENU: retorno
      });
    }
  }
};
</script>
